export default __webpack_public_path__ + "static/media/Minesweeper.37586e30.webp";